import React, { Component } from "react";

import "./StoryArrows.scss"

class StoryArrows extends Component {
  constructor() {
    super();
    this.state = {
      currItem: 0
    }
  }
  componentDidMount() {
    this.setState({
      currItem: this.props.currItem
    })
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      currItem: nextProps.currItem
    })
  }
  render() {
    return (
      <nav>
        <div className="padding">
          <div className="container">
            <div onClick={(item) => this.props.navigate(this.state.currItem - 1)} className="arrow right"></div>
            <div onClick={(item) => this.props.navigate(this.state.currItem + 1)} className="arrow left"></div>
          </div>
        </div>
      </nav>
    );
  }
}

export default StoryArrows;



// WEBPACK FOOTER //
// ./src/Components/MustKnow/StoryArrows.js